var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { alpha, lighten, makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiButton from "@material-ui/core/Button";
import clsx from "clsx";
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        disabled: {},
        focusVisible: {},
        startIcon: {},
        endIcon: {},
        containedPrimary: {},
        containedSecondary: {},
        outlinedPrimary: {},
        outlinedSecondary: {},
        innerLabel: {},
        progress: {
            position: "absolute",
        },
        loading: {
            "&$disabled": {
                opacity: 1,
                "&$containedPrimary": {
                    backgroundColor: alpha(palette.primary.main, palette.action.disabledOpacity),
                },
                "&$containedSecondary": {
                    backgroundColor: alpha(palette.secondary.main, palette.action.disabledOpacity),
                },
                "&$outlinedPrimary": {
                    borderColor: alpha(palette.primary.main, palette.action.disabledOpacity),
                },
                "&$outlinedSecondary": {
                    borderColor: palette.divider,
                },
                "&$success": {
                    backgroundColor: alpha(palette.success.main, palette.action.disabledOpacity),
                },
                "&$warning": {
                    backgroundColor: alpha(palette.warning.main, palette.action.disabledOpacity),
                },
                "&$error": {
                    backgroundColor: alpha(palette.error.main, palette.action.disabledOpacity),
                },
            },
            "& $innerLabel, & $startIcon, & $endIcon": {
                opacity: 0,
            },
            "& $progress": {
                opacity: 1,
            },
        },
        success: {
            backgroundColor: palette.success.main,
            "&:hover:not($loading), &$focusVisible": {
                backgroundColor: lighten(palette.success.main, palette.action.hoverOpacity),
            },
        },
        warning: {
            backgroundColor: palette.warning.main,
            color: palette.warning.contrastText,
            "&:hover:not($loading), &$focusVisible": {
                backgroundColor: lighten(palette.warning.main, palette.action.hoverOpacity),
            },
        },
        error: {
            backgroundColor: palette.error.main,
            "&:hover:not($loading), &$focusVisible": {
                backgroundColor: lighten(palette.error.main, palette.action.hoverOpacity),
            },
        },
    });
}, { name: "EuiButton" });
export var Button = React.forwardRef(function Button(_a, ref) {
    var _b, _c;
    var colorProp = _a.color, loading = _a.loading, loadingLabel = _a.loadingLabel, classesProp = _a.classes, children = _a.children, props = __rest(_a, ["color", "loading", "loadingLabel", "classes", "children"]);
    var classes = useStyles();
    var color = colorProp === "error" || colorProp === "success" || colorProp === "warning"
        ? undefined
        : colorProp;
    return (React.createElement(MuiButton, __assign({ disabled: loading }, props, { color: color, classes: __assign(__assign({}, classesProp), { root: clsx((_b = {}, _b[classes.loading] = loading, _b), classesProp === null || classesProp === void 0 ? void 0 : classesProp.root), contained: clsx((_c = {},
                _c[classes.warning] = colorProp === "warning",
                _c[classes.success] = colorProp === "success",
                _c[classes.error] = colorProp === "error",
                _c), classesProp === null || classesProp === void 0 ? void 0 : classesProp.contained), focusVisible: clsx(classes.focusVisible, classesProp === null || classesProp === void 0 ? void 0 : classesProp.focusVisible), disabled: clsx(classes.disabled, classesProp === null || classesProp === void 0 ? void 0 : classesProp.disabled), startIcon: clsx(classes.startIcon, classesProp === null || classesProp === void 0 ? void 0 : classesProp.startIcon), endIcon: clsx(classes.endIcon, classesProp === null || classesProp === void 0 ? void 0 : classesProp.endIcon), containedPrimary: clsx(classes.containedPrimary, classesProp === null || classesProp === void 0 ? void 0 : classesProp.containedPrimary), containedSecondary: clsx(classes.containedSecondary, classesProp === null || classesProp === void 0 ? void 0 : classesProp.containedSecondary), outlinedPrimary: clsx(classes.outlinedPrimary, classesProp === null || classesProp === void 0 ? void 0 : classesProp.outlinedPrimary), outlinedSecondary: clsx(classes.outlinedSecondary, classesProp === null || classesProp === void 0 ? void 0 : classesProp.outlinedSecondary) }), ref: ref }),
        React.createElement("span", { className: classes.innerLabel }, children),
        loading && (React.createElement(CircularProgress, { "aria-label": loadingLabel, className: classes.progress, color: "inherit", size: 20 }))));
});
//# sourceMappingURL=Button.js.map